export const IMAGES = new Map([
  [0, 'sun.png'],
  [1, 'sun.png'],
  [2, 'partly-cloudy.png'],
  [3, 'overcast.png'],
  [45, 'fog.png'],
  [48, 'fog.png'],
  [51, 'drizzle.png'],
  [53, 'drizzle.png'],
  [55, 'drizzle.png'],
  [56, 'drizzle.png'],
  [57, 'drizzle.png'],
  [61, 'slight-rain.png'],
  [63, 'slight-rain.png'],
  [65, 'heavy-rain.png'],
  [66, 'heavy-rain.png'],
  [67, 'heavy-rain.png'],
  [71, 'slight-snowfall.png'],
  [73, 'slight-snowfall.png'],
  [75, 'heavy-snowfall.png'],
  [77, 'heavy-snowfall.png'],
  [80, 'slight-rain.png'],
  [81, 'slight-rain.png'],
  [82, 'heavy-rain.png'],
  [85, 'slight-snowfall.png'],
  [86, 'heavy-snowfall.png'],
  [95, 'storm.png'],
  [96, 'hail.png'],
  [99, 'hail.png'],
]);
